<div class="screen-share" [attr.aria-busy]="isCreatingPersona">
  <span class="screen-share-label">
    {{ 'simulationBuilder.SCREEN_SHARE_TITLE' | transloco }}
  </span>

  <p class="screen-share-description">
    {{ 'simulationBuilder.SCREEN_SHARE_DESCRIPTION' | transloco }}
  </p>

  <div class="screen-share-toggle" [class.disabled]="toggleDisabled">
    <input
      qai-toggle-switch
      type="checkbox"
      [size]="'small'"
      [name]="'screen-share'"
      [checked]="toggleOn"
      [disabled]="toggleDisabled"
      [attr.aria-describedby]="!hasPersona ? 'screen-share-no-persona' : null"
      (change)="onToggleInputChange($event)"
    />

    <div class="screen-share-toggle-copy">
      <span class="screen-share-toggle-status">
        {{ 'simulationBuilder.' + statusLabelKey | transloco }}
      </span>
      @if (!hasPersona) {
        <span
        class="screen-share-no-persona"
        id="screen-share-no-persona"
        >
        {{ 'simulationBuilder.SCREEN_SHARE_NO_PERSONA' | transloco }}
      </span>
    }
      @if (conversePromptManualOverride()) {
        <span class="screen-share-override-message">
          {{ 'simulationBuilder.SCREEN_SHARE_OVERRIDE_MESSAGE_PREFIX' | transloco }}
          <a href="mailto:help@quantified.ai">help&#64;quantified.ai</a>
          {{ 'simulationBuilder.SCREEN_SHARE_OVERRIDE_MESSAGE_SUFFIX' | transloco }}
        </span>
      }
    </div>
  </div>

  @if (isCreatingPersona) {
    <div class="screen-share-overlay">
      <qai-loading size="small" />
    </div>
  }
</div>
